import { render, staticRenderFns } from "./MaterialTabs.yaml?vue&type=template&id=30e6dcd1&component"
import script from "./MaterialTabs.yaml?vue&type=script&lang=ts&component"
export * from "./MaterialTabs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports